import gql from "graphql-tag"

const GET_ORDER = gql`
  query getOrder($id: ID!) {
    Order {
      history(id: $id) {
        history {
          message
          comment {
            text
          }
          operation
          operationId
          status
          actor {
            id
            name
            type
          }
          reason {
            code
            cause
          }
          timestamp
          type
          errorMessage
        }
        operations {
          delivered {
            bonus{
              amount
            }
            giftCards {
              amount
              giftCardId
            }
            gifts {
              giftId
              quantity
            }
            giftCardProducts {
              giftCardProductId
            }
            orderLines {
              orderLineId
              quantity
            }
            shippingFees {
              shippingFeeId
            }
            vouchers {
              amount
              voucherId
            }
          }
          refunded {
            bonus {
              amount
            }
            giftCards {
              amount
              giftCardId
            }
            gifts {
              giftId
              quantity
            }
            orderLines {
              orderLineId
              quantity
            }
            shippingFees {
              shippingFeeId
            }
            vouchers {
              amount
              voucherId
            }
          }
          compensated {
            payment {
              amount
            }
            bonus {
              amount
            }
            giftCards {
              amount
              giftCardId
            }
          }
          released {
            bonus{
              amount
            }
            giftCards {
              amount
              giftCardId
            }
            gifts {
              giftId
              quantity
            }
            giftCardProducts {
              giftCardProductId
            }
            orderLines {
              orderLineId
              quantity
            }
            shippingFees {
              shippingFeeId
            }
            vouchers {
              amount
              voucherId
            }
          }
        }
      }
      details(id: $id) {
        id
        date
        reference
        languageCode
        countryCode
        currencyCode
        storeGroupId
        taxProvider {
          providerId
          providerName
          status {
            history {
              status
              type
              message
              timestamp
            }
          }
        }
        gifts {
          id
          displayName
          productParentId
          productVariantId
          quantity
          basePriceAmount
          salePriceAmount
          totalPriceAmount
          discountAmount
          currencyCode
          totalTaxAmount
          taxPercentage
          taxPercentageDecimals
          imageUrl
        }
        isTaxIncludedInPrice
        attributes {
          merchantReference1
          merchantReference2
          company {
            name
            reference
            registrationNumber
            taxId
          }
        }
        totals {
          subTotal
          taxTotal
          giftCardTotal
          discountTotal
          shippingTotal
          grandTotal
          bonusTotal
        }
        Bundles {
          bundleGroupId
          id
          discountAmount
          currencyCode
        }
        discountCodeRules {
          id
          name
          code
          currencyCode
          discountAmount
          freeShipping
        }
        discountRules {
          id
          name
          currencyCode
          discountAmount
          freeShipping
        }
        discountExternalRules {
          currencyCode
          discountAmount
          freeShipping
          id
          name
          reference
        }
        discountOutcome {
          discountReduction
          totalDiscountAmount
          freeShipping
          cartRules {
            discountAmount
            ruleId
          }
          codeRules {
            code
            discountAmount
            ruleId
          }
          externalRules {
            discountAmount
            reference
            ruleId
          }
        }
        shippingFees {
          id
          name
          displayName
          taxGroupId
          currencyCode
          basePriceAmount
          salePriceAmount
          discountAmount
          taxAmount
          taxPercentage
          taxPercentageDecimals
        }
        externalPriceProvider {
          providerId
          providerName
        }
        orderLines {
          id
          quantity
          productVariantId
          productParentId
          name
          displayName
          description
          displayDescription
          taxGroupId
          taxCode
          currencyCode
          options {
            key
            value
          }
          dimensions {
            height
            width
            length
          }
          weight
          basePriceAmount
          salePriceAmount
          hasExternalPrice
          discountAmount
          taxPercentage
          taxPercentageDecimals
          imageUrl
          totalPriceAmount
          totalTaxAmount
          totalDiscountAmount
          distributedTotalPriceAmount
          distributedTotalTaxAmount
          distributedTotalDiscountAmount
          campaign {
            campaignId
            campaignGroupId
            name
          }
          discountOutcome {
            totalDiscountAmount
            bundles {
              bundleGroupId
              bundleId
              discountAmount
            }
            cartRules {
              discountAmount
              ruleId
            }
            codeRules {
              code
              discountAmount
              ruleId
            }
            externalRules {
              discountAmount
              reference
              ruleId
            }
          }
        }
        shippingAddress {
          givenName
          familyName
          email
          telephoneNumber
          streetAddress
          streetAddress2
          postalCode
          city
          stateOrProvince
          country
          pcc
        }
        billingAddress {
          givenName
          familyName
          email
          telephoneNumber
          streetAddress
          streetAddress2
          postalCode
          city
          stateOrProvince
          country
        }
        status {
          orderStates
          customStates {
            id
            operations
            type
          }
        }

        Payment {
          __typename
          providerId
          providerName
          reference
          method

          ... on OrderPaymentAdyen {
            status
            merchantAccountCode
            failedReason
            potentialFraud
            deepLinkPath
          }

          ... on OrderPaymentKlarnaCheckout {
            authorizationExpiresAt
            completedAt
            status
            fraudStatus
            klarnaMerchantId
            klarnaReference
            klarnaOrderId
            deepLinkPath
            providerId
            providerName
            reference
            remainingAuthorizedAmount
            customer {
              dateOfBirth
              type
            }
            initialPaymentMethod {
              description
              numberOfInstallments
              type
            }
            upsell {
              isTaxIncludedInPrice
              success
              items {
                displayName
                currencyCode
                productVariantId
                quantity
                totalDiscountAmount
                totalTaxAmount
              }
              totals {
                currencyCode
                discountTotal
                grandTotal
                subTotal
                taxTotal
              }
            }
          }

          ... on OrderPaymentSveaCheckout {
            status
            sveaMerchantId
            sveaOrderId
            expirationDate
            peppolId
            isCompany
          }

          ... on OrderPaymentWalleyCheckout {
            amountToPay
            purchaseIdentifier
            purchaseResult
            status
            totalAmount
          }

          ... on OrderPaymentQliroOne {
            status
            paymentTypeCode
            requireIdentityVerification
            identityVerified
            qliroOrderId
            signupForNewsletter
            merchantProvidedQuestionAnswer
            orderItems {
              merchantReference
              paymentTransactionId
            }
            upsell {
              isTaxIncludedInPrice
              status
              items {
                displayName
                productVariantId
                quantity
                totalDiscountAmount
                totalPriceAmount
                totalTaxAmount
              }
              totals {
                discountTotal
                grandTotal
                subTotal
                taxTotal
              }
            }
          }
          ... on OrderPaymentAvarda {
            status
            purchaseId
          }
          ... on OrderPaymentBrinkZeroPayment {
            originalProvider {
              id
              name
            }
          }
          ... on OrderPaymentZaver {
            status
            useVerifiedAddress
          }
          ... on OrderPaymentLedyer {
            companyId
            companyName
            ledyerOrderId
            status
            vatId
          }
        }
        Shipping {
          __typename
          providerId
          providerName
          reference
          ... on OrderShippingAvardaShippingBroker {
            shippingBroker
            avardaShipping: shipping {
              ingrid {
                deliveryType
                tosId
                carrier
                externalMethodId
                location {
                  externalId
                  address {
                    addressLines
                    city
                    name
                    postalCode
                  }
                }
              }
            }
          }
          ... on OrderShippingIngrid {
            deliveries {
              name
              deliveryType
              tosId
              carrierProductId
              deliveryAddress {
                name
                addressLines
                city
                postalCode
              }
            }
          }
          ... on OrderShippingWalleyDeliveryModule {
            orderId
            providerId
            providerName
            purchaseIdentifier
            reference
            walleyShipping: shipping {
              provider
              shippingFee
              shipments {
                bookedShipmentId
                externalShipmentId
                feeItemId
                id
                name
                shippingChoice {
                  destination {
                    deliveryDate {
                      date
                      fee
                      timeFrom
                      timeTo
                    }
                    fee
                    id
                    name
                  }
                  fee
                  id
                  name
                  options {
                    fee
                    type
                    value
                    description
                    id
                  }
                }
              }
            }
          }
          ... on OrderShippingQliroIntegratedShipping {
            ingrid {
              checkoutSessionId
              deliveries {
                name
                deliveryType
                tosId
                carrierProductId
                deliveryAddress {
                  name
                  addressLines
                  city
                  postalCode
                }
              }
            }
          }
          ... on OrderShippingKlarnaShippingAssistant {
            klarnaMerchantId
            klarnaOrderId
            orderId
            providerId
            providerName
            reference
            selectedShippingOption {
              carrier
              carrierProduct {
                identifier
                name
              }
              location {
                id
                name
                price
                address {
                  city
                  country
                  postalCode
                  region
                  streetAddress
                  streetAddress2
                }
              }
              name
              price
              selectedAddons {
                externalId
                price
                type
                userInput
              }
              taxAmount
              taxRate
              timeslot {
                cutoff
                end
                id
                price
                start
              }
              tmsReference
              type
            }
          }
          ... on OrderShippingNshift {
            preparedShipment {
              agent {
                address1
                address2
                city
                country
                email
                mobile
                name
                phone
                quickId
                state
                zipCode
              }
              orderNo
              prepareId
              sender {
                address1
                address2
                city
                country
                email
                mobile
                name
                phone
                quickId
                state
                zipCode
              }
              service {
                id
                name
                sourceSystem
                title
              }
            }
          }
        }
        GiftCard {
          __typename
          orderId
          providerId
          providerName
          status

          ... on OrderGiftCardBSGGiftCard {
            giftCards {
              id
              amount
              currencyCode
              reservationId
              status
              failedReason
            }
          }

          ... on OrderGiftCardKBSGiftCard {
            giftCards {
              id
              amount
              currencyCode
              reservationId
              status
              failedReason
            }
          }

          ... on OrderGiftCardRetain24 {
            giftCards {
              id
              amount
              currencyCode
              reservationId
              status
              failedReason
            }
          }
        }
        GiftCardProduct {
          ... on OrderGiftCardProductRetain24 {
            __typename
            giftCardProducts {
              amount
              currencyCode
              distribution
              emailText
              id
              name
              recipient
              merchantReference
              referenceNumber
              sendDate
              smsText
              templateId
            }
            orderId
            providerId
            providerName
          }
        }
        Promotion {
          orderId
          providerId
          providerName
          status
          ... on OrderPromotionVoyado {
            __typename
            contactId
            promotions {
              value
              failedReason
              id
              status
            }
          }
        }
        Voucher {
          providerName
          providerId
          orderId
          status
          ... on OrderVoucherVoyado {
            __typename
            contactId
            vouchers {
              amount
              checkNumber
              currencyCode
              failedReason
              id
              status
            }
          }
        }
        Bonus {
          amount
          currencyCode
          customerId
          failedReason
          points
          providerId
          providerName
          reservationId
          status
        }
        Deliveries {
          id
          started
          failed
          completed
          reason {
            code
            cause
          }
          created
          restarts
          restarted
          totals {
            subTotal
            shippingTotal
            giftCardTotal
            bonusTotal
            grandTotal
            taxTotal
          }
          reason {
            code
            cause
          }
          capturedPayment {
            reference
          }
          vouchers {
            amount
            currencyCode
            voucherId
          }
          orderLines {
            currencyCode
            orderLineId
            quantity
            taxPercentage
            taxPercentageDecimals
            totalAmount
            totalDiscountAmount
            totalTaxAmount
          }
          gifts {
            giftId
            quantity
          }
          giftCardProvider {
            providerName
            providerId
          }
          giftCards {
            amount
            giftCardId
            reservationId
            status
            currencyCode
          }
          giftCardProducts {
            giftCardProductId
            priceAmount
            currencyCode
            createId
          }
          bonusProvider {
            providerName
            providerId
          }
          taxProvider {
            providerId
            providerName
          }
          bonus {
            amount
            reservationId
          }
          shippingProvider {
            providerName
            providerId
          }
          paymentProvider {
            providerName
            providerId
          }
          shippingFees {
            currencyCode
            shippingFeeId
            totalAmount
            totalTaxAmount
          }
          tracking {
            reference
            shippingCompany
            shippingMethod
            url
          }
        }
        Modifications {
          id
          started
          completed
          failed
          created
          updated
          restarts
          restarted
          revision
          bonusProvider {
            providerName
            providerId
          }
          taxProvider {
            providerId
            providerName
          }
          giftCardProductProvider {
            providerId
            providerName
            status {
              current
              history {
                message
                status
                timestamp
                type
              }
            }
          }
          giftCardProvider {
            providerId
            providerName
          }
          paymentProvider {
            providerId
            providerName
          }
          reason {
            code
            cause
          }
          type
          ... on OrderModificationAddresses {
            addresses {
              data {
                shippingAddress {
                  givenName
                  familyName
                  email
                  telephoneNumber
                  streetAddress
                  streetAddress2
                  postalCode
                  city
                  stateOrProvince
                  country
                  pcc
                }
                billingAddress {
                  givenName
                  familyName
                  email
                  telephoneNumber
                  streetAddress
                  streetAddress2
                  postalCode
                  city
                  stateOrProvince
                  country
                  pcc
                }
              }
            }
          }
          ... on OrderModificationShippingFees {
            id
            orderReference
            oldTotals {
              subTotal
              discountTotal
              grandTotal
              taxTotal
            }
            newTotals {
              subTotal
              discountTotal
              grandTotal
              taxTotal
            }
            shippingFees {
              data {
                ... on ShippingFeeModificationUpdateData {
                  id
                  price {
                    basePriceAmount
                    discountAmount
                    salePriceAmount
                    taxPercentage
                    taxPercentageDecimals
                  }
                }
              }
              modificationType
            }
          }
          ... on OrderModificationOrderLines {
            id
            orderReference
            oldTotals {
              subTotal
              discountTotal
              grandTotal
              taxTotal
            }
            newTotals {
              subTotal
              discountTotal
              grandTotal
              taxTotal
            }
            orderLines {
              data {
                ... on OrderLineModificationCreateData {
                  id
                  name
                  productVariantId
                  basePriceAmount
                  description
                  discountAmount
                  imageUrl
                  productParentId
                  quantity
                  salePriceAmount
                  totalDiscountAmount
                  distributedTotalPriceAmount
                  totalPriceAmount
                  totalTaxAmount
                  taxPercentage
                  taxPercentageDecimals
                }
                ... on OrderLineModificationDeleteData {
                  id
                  productVariantId
                  name
                  imageUrl
                  quantity
                  salePriceAmount
                }
                ... on OrderLineModificationUpdateData {
                  id
                  name
                  description
                  displayName
                  displayDescription
                  imageUrl
                  price {
                    basePriceAmount
                    discountAmount
                    salePriceAmount
                    totalPriceAmount
                    totalTaxAmount
                    taxPercentage
                    taxPercentageDecimals
                    distributedTotalDiscountAmount
                    distributedTotalPriceAmount
                    quantity
                  }
                  productVariantId
                  productParentId
                }
              }
              modificationType
            }
          }
        }
        Refunds {
          id
          started
          completed
          failed
          created
          updated
          restarts
          restarted
          giftCards {
            amount
            currencyCode
            giftCardId
            status
          }
          giftCardProducts {
            giftCardProductId
            priceAmount
            currencyCode
            status
          }
          fee {
            amount
            currencyCode
            name
            taxAmount
            taxPercentage
            taxPercentageDecimals
          }
          giftCardProvider {
            providerId
            providerName
          }
          taxProvider {
            providerId
            providerName
          }
          shippingFees {
            currencyCode
            shippingFeeId
            taxPercentage
            taxPercentageDecimals
            totalAmount
            totalDiscountAmount
            totalTaxAmount
          }
          bonus {
            reservationId
            currencyCode
            amount
          }
          bonusProvider {
            providerId
            providerName
          }
          paymentProvider {
            providerId
            providerName
          }
          refundedPayment {
            reference
          }
          reason {
            cause
            code
          }
          gifts {
            giftId
            quantity
          }
          totals {
            subTotal
            shippingTotal
            giftCardTotal
            bonusTotal
            grandTotal
            taxTotal
          }
          orderLines {
            currencyCode
            orderLineId
            quantity
            taxPercentage
            taxPercentageDecimals
            totalAmount
            totalDiscountAmount
            totalTaxAmount
          }
        }
        Releases {
          id
          started
          failed
          completed
          created
          updated
          restarts
          restarted
          revision
          reason {
            cause
            code
          }
          releasedPayment {
            reference
          }
          orderLines {
            currencyCode
            orderLineId
            quantity
            taxPercentage
            taxPercentageDecimals
            totalAmount
            totalDiscountAmount
            totalTaxAmount
          }
          gifts {
            giftId
            quantity
          }
          giftCardProvider {
            providerName
            providerId
          }
          taxProvider {
            providerId
            providerName
          }
          giftCards {
            amount
            giftCardId
            status
            currencyCode
          }
          giftCardProductProvider {
            providerId
            providerName
            status {
              current
              history {
                message
                status
                timestamp
                type
              }
            }
          }
          giftCardProducts {
            cancelErrorMessage
            cancelErrorMessage
            cancelTransactionId
            createFailedReason
            createId
            createTransactionId
            currencyCode
            giftCardProductId
            priceAmount
            status
          }
          bonusProvider {
            providerName
            providerId
          }
          bonus {
            amount
            reservationId
          }
          shippingProvider {
            providerName
            providerId
          }
          paymentProvider {
            providerName
            providerId
          }
          voucherProvider {
            providerName
            providerId
          }
          shippingFees {
            currencyCode
            shippingFeeId
            totalAmount
          }
        }
        Cancellations {
          id
          orderId
          completed
          started
          failed
          restarts
          restarted
          reason {
            cause
            code
          }
          cancelledPayment {
            reference
          }
          bonusProvider {
            providerId
            providerName
          }
          taxProvider {
            providerId
            providerName
          }
          paymentProvider {
            providerId
            providerName
          }
          bonusProvider {
            providerId
            providerName
          }
          bonus {
            reservationId
            status
          }
          giftCards {
            reservationId
            status
          }
        }
        Compensations {
          bonus {
            amount
            currencyCode
            reservationId
          }
          bonusProvider {
            providerId
            providerName
          }
          taxProvider {
            providerId
            providerName
          }
          completed
          created
          failed
          giftCardProvider {
            providerId
            providerName
          }
          giftCards {
            giftCardId
            amount
          }
          id
          orderLines {
            currencyCode
            imageUrl
            name
            orderLineId
            quantity
            taxPercentage
            taxPercentageDecimals
            totalAmount
            totalDiscountAmount
            totalTaxAmount
          }
          payment {
            amount
            currencyCode
            reference
          }
          paymentProvider {
            providerId
            providerName
          }
          reason {
            cause
            code
          }
          fee {
            amount
            currencyCode
            name
            taxAmount
            taxPercentage
            taxPercentageDecimals
          }
          restarted
          restarts
          revision
          shippingFees {
            currencyCode
            name
            shippingFeeId
            taxPercentage
            taxPercentageDecimals
            totalAmount
            totalDiscountAmount
            totalTaxAmount
          }
          started
          totals {
            bonusTotal
            giftCardTotal
            grandTotal
            paymentTotal
          }
          updated
        }

      }
    }
  }
`

export default GET_ORDER
